var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customer-form-component',{attrs:{"mode":"create","error":_vm.responseError,"loading":_vm.loading},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }